import React from 'react';

const UpdatePTLConsignments = (props) => {
    // console.log(props,"QQQQQQQQQQQQQQQQQ");
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // Prevent action if disabled
        if (!props.disabled) {
            props.onClickActive(props);
        }
        
    };

    return (
        <div className="map-icon-component" style={{ cursor: props.disabled ? "not-allowed" : "pointer" }}>
            {/* Conditionally render different icons based on iconType and disabled status */}
            {props.iconType === "tracking" && (props.data.status === 6|| props.data.status === 8 || props.data.status === 5 || props.data.consignment_status === "Cancelled" || props.data.consignment_status === "Delivered" || props.disabled ) ? ( // Check if iconType is not 'edit' and disabled is true
                <img 
                    src={require("../../assets/images/edit_location_disabled.png")} 
                    style={{ height:"17px", color: "gray" }}  // Disabled icon styling
                    alt="Update Tracking Status" 
                    title="Update Tracking Status" 
                />
            ): (
                <img 
                    onClick={handleRouteClick}  
                    src={require("../../assets/images/edit_location.png")} 
                    style={{ height:"17px", color: props.disabled ? "gray" : "black" }}
                    alt="Update Tracking Status" 
                    title='Update Tracking Status'
                />
            )}
        </div>
    );
};

export default UpdatePTLConsignments;
